import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';

const INITIAL_STATE = {
    beneficios: {},
    loading: [],
    loadingEco: false,
    erroEco: null,
    loadingPdf: false,
    openDialog:false,
    contratoSelecionado:null,
    tipoContratoSelecionado:'',
    openDialogDetailEmprestimo:false,
    mensagem: ''
};

const removeFromLoading = (state, nb) => {

    let numero = nb.toString().replace(/\D+/g, "");
    let newLoading = state.loading;
    if(newLoading.indexOf(numero) > -1) {
        newLoading.splice(newLoading.indexOf(numero), 1);
    }
    return newLoading;
}

const MSG_BENEFICIO_INEXISTENTE = 'Tipo de benefício não permite empréstimo.';
const MSG_INFO_NAO_ENCONTRADAS = 'Informações sobre Consignados não encontradas.';


export default (state = INITIAL_STATE, action) => {

    switch (action.type){

        case 'ECO_EXTRATO_INIT':
            return {...state, loadingEco: false, beneficios: {}, erroEco: null, mensagem: ''}

        case 'ECO_EXTRATO_SOLICITADOS':
            let newLoadingStatus = state.loading;
            if(newLoadingStatus.indexOf(action.payload.nb) < 0){
                newLoadingStatus.push(action.payload.nb);    
            }

            return { ...state, loading: newLoadingStatus, erroEco: null, loadingEco: true, loadingPdf: true, mensagem: '', error: false };

        case 'ECO_EXTRATO_RECEBIDO':
            action.payload.listaExtratosConsignados = Array.isArray(action.payload.listaExtratosConsignados) ? 
                action.payload.listaExtratosConsignados[0] : 
                action.payload.listaExtratosConsignados;

            let nb = action.payload.listaExtratosConsignados.nb.replace(/\D+/g, "");
            let newLoading = state.loading;
            if(newLoading.indexOf(nb) > -1) {
                newLoading.splice(newLoading.indexOf(nb), 1);
            }

            return {
                ...state, 
                loadingEco: false,
                beneficios: {...state.beneficios, [nb]: action.payload.listaExtratosConsignados}, 
                loading: newLoading, loadingPdf: false, mensagem: '', erroEco: false
            };

        case 'ECO_ERRO_4xx_RECEBIDO':
                
                return {...state,
                    loading: removeFromLoading(state, action.nb),
                    erroEco: 'erro',
                    loadingEco: false,
                    loadingPdf:false, 
                    mensagem: '',
                    error: true,
                    beneficios: {
                        ...state.beneficios,
                        [action.nb]: {
                            status: action.status,
                            notFound: (action.status === 404),
                            message: action.status === 404 ? (MSG_INFO_NAO_ENCONTRADAS) : (action.httpCode === 412 ? MSG_BENEFICIO_INEXISTENTE : MSG_ERRO_SERVIDOR)
                        }
                    },
                }

        case 'ECO_ERRO_5xx_RECEBIDO':
            return {...state, 
                loadingEco: false,
                loadingPdf:false, 
                mensagem: '',
                error: true,
                loading: removeFromLoading(state, action.nb),
                beneficios: {...state.beneficios, [action.nb]: {status: 500, message: MSG_ERRO_SERVIDOR}},
            };

        case 'ECO_IMPRESSAO_SOLICITADA':
            return {...state, loadingPdf: true, loadingEco: false, mensagem: '', erroEco: false}

        case 'ECO_IMPRESSAO_ERRO':
            return {...state, loadingEco: false, erroEco: true, mensagem: ''}

        case 'ECO_PDF_RECEBIDO':
            return {...state, loadingPdf: false, loadingEco: false, erroEco: false, mensagem: 'sucesso'};
      
        case 'ECO_OPEN_DIALOG_DETAIL_EMPRESTIMO_CONTRATO':
            return { ...state, contratoSelecionado: action.payload.contrato,tipoContratoSelecionado:action.payload.tipoContratoSelecionado, openDialogDetailEmprestimo:true }
        
        case 'ECO_CLOSE_DIALOG_DETAIL_EMPRESTIMO_CONTRATO':
            return { ...state, openDialogDetailEmprestimo:false,tipoContratoSelecionado:'' }

        case 'ECO_VOLTAR':
            return { ...state, beneficio: undefined, mensagem: '' }

        case 'ECO_LIMPAR_MENSAGEM':
            return {...state, loadingPdf: false, erroEco: false, mensagem: ''}   

        default:
            return state;
    }
}
